// Display projection only. The API validates allocations and freezes the actual
// receipt policy before charging; this quote never authorizes an emission.
function pledgeReceiptSummary(config, amount, contractAmount) {
    const total = Math.round(Number(amount) * 100)
    if (!Number.isSafeInteger(total) || total <= 0) return null
    const allowed = config.cerfa !== false && config.pledgeReceiptAllowed !== false
    if (config.type === 'DETTE')
        return { total, fiscal: allowed && config.dette?.cerfa !== false ? total : 0 }
    if (config.type !== 'MULTI_DETTE' || !Array.isArray(config.dettes)) return null
    const envelope = contractAmount ? Number(contractAmount) : total
    if (!Number.isSafeInteger(envelope) || envelope < total) return null
    let remaining = envelope
    const parts = []
    for (const pledge of config.dettes) {
        const due = Math.round(Number(pledge.reste ?? pledge.montant) * 100)
        if (!Number.isSafeInteger(due) || due < 0) return null
        const amount = Math.min(remaining, due)
        if (amount) parts.push({ id: pledge.id, amount, cerfa: pledge.cerfa !== false })
        remaining -= amount
        if (!remaining) break
    }
    if (contractAmount) {
        if (remaining) return null
        // Same largest-remainder tie break as the server occurrence allocator.
        let missing = total
        for (const part of parts) {
            const numerator = BigInt(total) * BigInt(part.amount)
            part.minor = Number(numerator / BigInt(envelope))
            part.remainder = numerator % BigInt(envelope)
            missing -= part.minor
        }
        parts.sort((a, b) =>
            a.remainder === b.remainder ? a.id.localeCompare(b.id) : a.remainder > b.remainder ? -1 : 1,
        )
        for (const part of parts)
            if (missing > 0) {
                part.minor++
                missing--
            }
    }
    const excluded = parts.reduce((sum, part) => sum + (part.cerfa ? 0 : (part.minor ?? part.amount)), 0)
    return { total, fiscal: allowed ? total - excluded : 0 }
}
module.exports = { pledgeReceiptSummary }
